import Vue from 'vue';

const ToolService = new Vue();

export default ToolService;
